module.exports = __webpack_public_path__ + "img/ringcase.7d4cf40.webp";